export let emailCheck = "/emailCheck";
export let phoneNumberCheck = "/phoneNumberCheck";
export let sendOtp = "/sendOtp";
export let verifyOtp = "/verifyOtp";
export let saveUserOrganizationInfo = "/saveUserOrganizationInfo";
export let loginUrlCheck = "/loginUrlCheck";
export let login = "/zetranApp/login";
export let myPlanLogin = "/login";
export let myPlanOauthLogin = "/oauth/login";
export let forgotPassword = "/forgotPassword";
export let setPassword = "/setPassword";
export let loginUser = "/loginUser";
export let deleteUserAccount = "/deleteUserAccount";
export let accountActivation = "/accountActivation";
export let approveEstimate = "/approveEstimate";
export let approveSupportAccess = "/approveSupportAccess";
export let signInCheck = "/signInCheck";

export function remove_hash_from_url() {
  var uri = window.location.toString();

  if (uri.indexOf("#") > 0) {
    var clean_uri = uri.substring(0, uri.indexOf("#"));

    window.history.replaceState({}, document.title, clean_uri);
  }
}

export function generateRandomString(length) {
  var result = "";
  var characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isNumber(str) {
  var reg = new RegExp("^[0-9]+$");
  return reg.test(str);
}

export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validatePassword(pw) {
  return (
    /[A-Z]/.test(pw) &&
    /[a-z]/.test(pw) &&
    /[0-9]/.test(pw) &&
    /[^A-Za-z0-9]/.test(pw) &&
    pw.length >= 8 &&
    pw.length <= 40
  );
}

export let CreateData = function (obj) {
  var str = [];
  for (var p in obj) {
    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
  }
  return str.join("&");
};

export let industryTypes = [
  { type: "Industries", industry_nm: "Agriculture and Farming" },
  { type: "Industries", industry_nm: "Art, Writing and Photography" },
  { type: "Industries", industry_nm: "Automotive" },
  { type: "Industries", industry_nm: "Construction and Services" },
  { type: "Industries", industry_nm: "Consultancy Services" },
  { type: "Industries", industry_nm: "Education and Services" },
  { type: "Industries", industry_nm: "Engineering, Design and Architecture" },
  { type: "Industries", industry_nm: "Entertainment" },
  { type: "Industries", industry_nm: "Financial Services" },
  { type: "Industries", industry_nm: "Food Services" },
  { type: "Industries", industry_nm: "Legal Services" },
  { type: "Industries", industry_nm: "Hospitality and Travel" },
  { type: "Industries", industry_nm: "Health Care" },
  { type: "Industries", industry_nm: "Manufacturing" },
  { type: "Industries", industry_nm: "Non-Profit" },
  { type: "Industries", industry_nm: "Publishing and Media" },
  { type: "Industries", industry_nm: "Real Estate" },
  { type: "Industries", industry_nm: "Retail" },
  { type: "Industries", industry_nm: "Sales Agency" },
  { type: "Industries", industry_nm: "Technology" },
  { type: "Industries", industry_nm: "Telecommunications" },
  { type: "Industries", industry_nm: "Transportation and Logistics" },
  { type: "Industries", industry_nm: "Generic Service Business" },
  { type: "Industries", industry_nm: "Generic Product Business" },
  { type: "Industries", industry_nm: "Trading" },
];

export let currencyData = [
  {
    type: "Currencies",
    currency_code: "AED-United Arab Emirates Dirham",
    currency_symbol: "د.إ",
    currency_country: "United Arab Emirates (UAE)",
  },
  {
    type: "Currencies",
    currency_code: "AFN-Afghanistan Afghani",
    currency_symbol: "؋",
    currency_country: "Afghanistan",
  },
  {
    type: "Currencies",
    currency_code: "ALL-Albania Lek",
    currency_symbol: "Lek",
    currency_country: "Albania",
  },
  {
    type: "Currencies",
    currency_code: "AMD-Armenia Dram",
    currency_symbol: "֏",
    currency_country: "Armenia",
  },
  {
    type: "Currencies",
    currency_code: "AOA-Angola Kwanza",
    currency_symbol: "Kz",
    currency_country: "Angola",
  },
  {
    type: "Currencies",
    currency_code: "ARS-Argentina Peso",
    currency_symbol: "$",
    currency_country: "Argentina",
  },
  {
    type: "Currencies",
    currency_code: "AUD-Australia Dollar",
    currency_symbol: "$",
    currency_country: "Australia",
  },
  {
    type: "Currencies",
    currency_code: "AWG-Aruba Guilder",
    currency_symbol: "ƒ",
    currency_country: "Aruba",
  },
  {
    type: "Currencies",
    currency_code: "AZN-Azerbaijan New Manat",
    currency_symbol: "₼",
    currency_country: "Azerbaijan",
  },
  {
    type: "Currencies",
    currency_code: "BAM-Bosnia and Herzegovina Convertible Marka",
    currency_symbol: "KM",
    currency_country: "Bosnia and Herzegovina",
  },
  {
    type: "Currencies",
    currency_code: "BBD-Barbados Dollar",
    currency_symbol: "Bds$",
    currency_country: "Barbados",
  },
  {
    type: "Currencies",
    currency_code: "BDT-Bangladesh Taka",
    currency_symbol: "৳",
    currency_country: "Bangladesh",
  },
  {
    type: "Currencies",
    currency_code: "BGN-Bulgaria Lev",
    currency_symbol: "Лв",
    currency_country: "Bulgaria",
  },
  {
    type: "Currencies",
    currency_code: "BHD-Bahrain Dinar",
    currency_symbol: ".د.ب",
    currency_country: "Bahrain",
  },
  {
    type: "Currencies",
    currency_code: "BIF-Burundi Franc",
    currency_symbol: "FBu",
    currency_country: "Burundi",
  },
  {
    type: "Currencies",
    currency_code: "BMD-Bermuda Dollar",
    currency_symbol: "$",
    currency_country: "Bermuda",
  },
  {
    type: "Currencies",
    currency_code: "BND-Brunei Darussalam Dollar",
    currency_symbol: "B$",
    currency_country: "Brunei Darussalam",
  },
  {
    type: "Currencies",
    currency_code: "BOB-Bolivia Boliviano",
    currency_symbol: "Bs",
    currency_country: "Bolivia",
  },
  {
    type: "Currencies",
    currency_code: "BRL-Brazil Real",
    currency_symbol: "R$",
    currency_country: "Brazil",
  },
  {
    type: "Currencies",
    currency_code: "BSD-Bahamas Dollar",
    currency_symbol: "B$",
    currency_country: "Bahamas",
  },
  {
    type: "Currencies",
    currency_code: "BTN-Bhutan Ngultrum",
    currency_symbol: "Nu.",
    currency_country: "Bhutan",
  },
  {
    type: "Currencies",
    currency_code: "BWP-Botswana Pula",
    currency_symbol: "P",
    currency_country: "Botswana",
  },
  {
    type: "Currencies",
    currency_code: "BYR-Belarus Ruble",
    currency_symbol: "Br",
    currency_country: "Belarus",
  },
  {
    type: "Currencies",
    currency_code: "BZD-Belize Dollar",
    currency_symbol: "$",
    currency_country: "Belize",
  },
  {
    type: "Currencies",
    currency_code: "CAD-Canada Dollar",
    currency_symbol: "C$",
    currency_country: "Canada",
  },
  {
    type: "Currencies",
    currency_code: "CDF-Congo/Kinshasa Franc",
    currency_symbol: "FC",
    currency_country: "Democratic Republic of the Congo",
  },
  {
    type: "Currencies",
    currency_code: "CHF-Switzerland Franc",
    currency_symbol: "Fr.",
    currency_country: "Switzerland",
  },
  {
    type: "Currencies",
    currency_code: "CLP-Chile Peso",
    currency_symbol: "$",
    currency_country: "Chile",
  },
  {
    type: "Currencies",
    currency_code: "CNY-China Yuan Renminbi",
    currency_symbol: "¥",
    currency_country: "China",
  },
  {
    type: "Currencies",
    currency_code: "COP-Colombia Peso",
    currency_symbol: "$",
    currency_country: "Colombia",
  },
  {
    type: "Currencies",
    currency_code: "CRC-Costa Rica Colon",
    currency_symbol: "₡",
    currency_country: "Costa Rica",
  },
  {
    type: "Currencies",
    currency_code: "CUC-Cuba Convertible Peso",
    currency_symbol: "CUC$",
    currency_country: "Cuba",
  },
  {
    type: "Currencies",
    currency_code: "CUP-Cuba Peso",
    currency_symbol: "$MN",
    currency_country: "Cuba",
  },
  {
    type: "Currencies",
    currency_code: "CVE-Cape Verde Escudo",
    currency_symbol: "$",
    currency_country: "Republic of Cape Verde",
  },
  {
    type: "Currencies",
    currency_code: "CZK-Czech Republic Koruna",
    currency_symbol: "Kč",
    currency_country: "Czech Republic",
  },
  {
    type: "Currencies",
    currency_code: "DJF-Djibouti Franc",
    currency_symbol: "Fdj",
    currency_country: "Djibouti",
  },
  {
    type: "Currencies",
    currency_code: "DKK-Denmark Krone",
    currency_symbol: "Kr.",
    currency_country: "Denmark",
  },
  {
    type: "Currencies",
    currency_code: "DOP-Dominican Republic Peso",
    currency_symbol: "RD$",
    currency_country: "Dominican Republic",
  },
  {
    type: "Currencies",
    currency_code: "DZD-Algeria Dinar",
    currency_symbol: "دج",
    currency_country: "Algeria",
  },
  {
    type: "Currencies",
    currency_code: "EGP-Egypt Pound",
    currency_symbol: "E£",
    currency_country: "Egypt",
  },
  {
    type: "Currencies",
    currency_code: "ERN-Eritrea Nakfa",
    currency_symbol: "نافكا",
    currency_country: "Eritrea",
  },
  {
    type: "Currencies",
    currency_code: "ETB-Ethiopia Birr",
    currency_symbol: "ብር",
    currency_country: "Ethiopia",
  },
  {
    type: "Currencies",
    currency_code: "EUR-Euro Member Countries",
    currency_symbol: "€",
    currency_country: "Euro Member Countries",
  },
  {
    type: "Currencies",
    currency_code: "FJD-Fiji Dollar",
    currency_symbol: "FJ$",
    currency_country: "Fiji",
  },
  {
    type: "Currencies",
    currency_code: "FKP-Falkland Islands (Malvinas) Pound",
    currency_symbol: "£",
    currency_country: "Falkland Islands (Malvinas)",
  },
  {
    type: "Currencies",
    currency_code: "GBP-United Kingdom Pound",
    currency_symbol: "£",
    currency_country: "United Kingdom (UK)",
  },
  {
    type: "Currencies",
    currency_code: "GEL-Georgia Lari",
    currency_symbol: "ლ",
    currency_country: "Georgia",
  },
  {
    type: "Currencies",
    currency_code: "GGP-Guernsey Pound",
    currency_symbol: "£",
    currency_country: "Guernsey",
  },
  {
    type: "Currencies",
    currency_code: "GHS-Ghana Cedi",
    currency_symbol: "GH₵",
    currency_country: "Ghana",
  },
  {
    type: "Currencies",
    currency_code: "GIP-Gibraltar Pound",
    currency_symbol: "£",
    currency_country: "Gibraltar",
  },
  {
    type: "Currencies",
    currency_code: "GMD-Gambia Dalasi",
    currency_symbol: "D",
    currency_country: "Gambia",
  },
  {
    type: "Currencies",
    currency_code: "GNF-Guinea Franc",
    currency_symbol: "GFr",
    currency_country: "Guinea",
  },
  {
    type: "Currencies",
    currency_code: "GTQ-Guatemala Quetzal",
    currency_symbol: "Q",
    currency_country: "Guatemala",
  },
  {
    type: "Currencies",
    currency_code: "GYD-Guyana Dollar",
    currency_symbol: "G$",
    currency_country: "Guyana",
  },
  {
    type: "Currencies",
    currency_code: "HKD-Hong Kong Dollar",
    currency_symbol: "HK$",
    currency_country: "Hong Kong",
  },
  {
    type: "Currencies",
    currency_code: "HNL-Honduras Lempira",
    currency_symbol: "L",
    currency_country: "Honduras",
  },
  {
    type: "Currencies",
    currency_code: "HRK-Croatia Kuna",
    currency_symbol: "kn",
    currency_country: "Croatia",
  },
  {
    type: "Currencies",
    currency_code: "HTG-Haiti Gourde",
    currency_symbol: "G",
    currency_country: "Haiti",
  },
  {
    type: "Currencies",
    currency_code: "HUF-Hungary Forint",
    currency_symbol: "Ft",
    currency_country: "Hungary",
  },
  {
    type: "Currencies",
    currency_code: "IDR-Indonesia Rupiah",
    currency_symbol: "Rp",
    currency_country: "Indonesia",
  },
  {
    type: "Currencies",
    currency_code: "ILS-Israel Shekel",
    currency_symbol: "₪",
    currency_country: "Israel",
  },
  {
    type: "Currencies",
    currency_code: "IMP-Isle of Man Pound",
    currency_symbol: "£",
    currency_country: "Isle of Man",
  },
  {
    type: "Currencies",
    currency_code: "INR-India Rupee",
    currency_symbol: "₹",
    currency_country: "India",
  },
  {
    type: "Currencies",
    currency_code: "IQD-Iraq Dinar",
    currency_symbol: "ع.د",
    currency_country: "Iraq",
  },
  {
    type: "Currencies",
    currency_code: "IRR-Iran Rial",
    currency_symbol: "﷼",
    currency_country: "Islamic Republic of Iran",
  },
  {
    type: "Currencies",
    currency_code: "ISK-Iceland Krona",
    currency_symbol: "kr",
    currency_country: "Iceland",
  },
  {
    type: "Currencies",
    currency_code: "JEP-Jersey Pound",
    currency_symbol: "£",
    currency_country: "Jersey",
  },
  {
    type: "Currencies",
    currency_code: "JMD-Jamaica Dollar",
    currency_symbol: "$",
    currency_country: "Jamaica",
  },
  {
    type: "Currencies",
    currency_code: "JOD-Jordan Dinar",
    currency_symbol: "د.ا",
    currency_country: "Jordan",
  },
  {
    type: "Currencies",
    currency_code: "JPY-Japan Yen",
    currency_symbol: "¥",
    currency_country: "Japan",
  },
  {
    type: "Currencies",
    currency_code: "KES-Kenya Shilling",
    currency_symbol: "Ksh",
    currency_country: "Kenya",
  },
  {
    type: "Currencies",
    currency_code: "KGS-Kyrgyzstan Som",
    currency_symbol: "Лв",
    currency_country: "Kyrgyzstan",
  },
  {
    type: "Currencies",
    currency_code: "KHR-Cambodia Riel",
    currency_symbol: "៛",
    currency_country: "Cambodia",
  },
  {
    type: "Currencies",
    currency_code: "KMF-Comoros Franc",
    currency_symbol: "CF",
    currency_country: "Comoros",
  },
  {
    type: "Currencies",
    currency_code: "KPW-Korea (North) Won",
    currency_symbol: "₩",
    currency_country: "Democratic People's Republic of Korea",
  },
  {
    type: "Currencies",
    currency_code: "KRW-Korea (South) Won",
    currency_symbol: "₩",
    currency_country: "Republic of Korea",
  },
  {
    type: "Currencies",
    currency_code: "KWD-Kuwait Dinar",
    currency_symbol: "د.ك",
    currency_country: "Kuwait",
  },
  {
    type: "Currencies",
    currency_code: "KYD-Cayman Islands Dollar",
    currency_symbol: "$",
    currency_country: "Cayman Islands",
  },
  {
    type: "Currencies",
    currency_code: "KZT-Kazakhstan Tenge",
    currency_symbol: "₸",
    currency_country: "Kazakhstan",
  },
  {
    type: "Currencies",
    currency_code: "LAK-Laos Kip",
    currency_symbol: "₭",
    currency_country: "Laos",
  },
  {
    type: "Currencies",
    currency_code: "LBP-Lebanon Pound",
    currency_symbol: "ل.ل.‎",
    currency_country: "Lebanon",
  },
  {
    type: "Currencies",
    currency_code: "LKR-Sri Lanka Rupee",
    currency_symbol: "Rs",
    currency_country: "Sri Lanka",
  },
  {
    type: "Currencies",
    currency_code: "LRD-Liberia Dollar",
    currency_symbol: "L$",
    currency_country: "Liberia",
  },
  {
    type: "Currencies",
    currency_code: "LSL-Lesotho Loti",
    currency_symbol: "L",
    currency_country: "Kingdom of Lesotho",
  },
  {
    type: "Currencies",
    currency_code: "LYD-Libya Dinar",
    currency_symbol: "ل.د",
    currency_country: "Libya",
  },
  {
    type: "Currencies",
    currency_code: "MAD-Morocco Dirham",
    currency_symbol: "د. م.",
    currency_country: "Morocco",
  },
  {
    type: "Currencies",
    currency_code: "MDL-Moldova Leu",
    currency_symbol: "L",
    currency_country: "Moldova",
  },
  {
    type: "Currencies",
    currency_code: "MGA-Madagascar Ariary",
    currency_symbol: "Ar",
    currency_country: "Madagascar",
  },
  {
    type: "Currencies",
    currency_code: "MKD-Macedonia Denar",
    currency_symbol: "Ден",
    currency_country: "Republic of Macedonia",
  },
  {
    type: "Currencies",
    currency_code: "MMK-Myanmar (Burma) Kyat",
    currency_symbol: "K",
    currency_country: "Myanmar (Burma)",
  },
  {
    type: "Currencies",
    currency_code: "MNT-Mongolia Tughrik",
    currency_symbol: "₮",
    currency_country: "Mongolia",
  },
  {
    type: "Currencies",
    currency_code: "MOP-Macau Pataca",
    currency_symbol: "MOP$",
    currency_country: "Macau",
  },
  {
    type: "Currencies",
    currency_code: "MRO-Mauritania Ouguiya",
    currency_symbol: "UM",
    currency_country: "Mauritania",
  },
  {
    type: "Currencies",
    currency_code: "MUR-Mauritius Rupee",
    currency_symbol: "Rs",
    currency_country: "Mauritius",
  },
  {
    type: "Currencies",
    currency_code: "MVR-Maldives (Maldive Islands) Rufiyaa",
    currency_symbol: "Rf",
    currency_country: "Maldives",
  },
  {
    type: "Currencies",
    currency_code: "MWK-Malawi Kwacha",
    currency_symbol: "MK",
    currency_country: "Malawi",
  },
  {
    type: "Currencies",
    currency_code: "MXN-Mexico Peso",
    currency_symbol: "Mex$",
    currency_country: "Mexico",
  },
  {
    type: "Currencies",
    currency_code: "MYR-Malaysia Ringgit",
    currency_symbol: "RM",
    currency_country: "Malaysia",
  },
  {
    type: "Currencies",
    currency_code: "MZN-Mozambique Metical",
    currency_symbol: "MT",
    currency_country: "Mozambique",
  },
  {
    type: "Currencies",
    currency_code: "NAD-Namibia Dollar",
    currency_symbol: "N$",
    currency_country: "Namibia",
  },
  {
    type: "Currencies",
    currency_code: "NGN-Nigeria Naira",
    currency_symbol: "₦",
    currency_country: "Nigeria",
  },
  {
    type: "Currencies",
    currency_code: "NIO-Nicaragua Cordoba",
    currency_symbol: "C$",
    currency_country: "Nicaragua",
  },
  {
    type: "Currencies",
    currency_code: "NOK-Norway Krone",
    currency_symbol: "kr",
    currency_country: "Norway",
  },
  {
    type: "Currencies",
    currency_code: "NPR-Nepal Rupee",
    currency_symbol: "Rs.",
    currency_country: "Nepal",
  },
  {
    type: "Currencies",
    currency_code: "NZD-New Zealand Dollar",
    currency_symbol: "$",
    currency_country: "New Zealand",
  },
  {
    type: "Currencies",
    currency_code: "OMR-Oman Rial",
    currency_symbol: "ر.ع.",
    currency_country: "Oman",
  },
  {
    type: "Currencies",
    currency_code: "PAB-Panama Balboa",
    currency_symbol: "B/.",
    currency_country: "Panama",
  },
  {
    type: "Currencies",
    currency_code: "PEN-Peru Nuevo Sol",
    currency_symbol: "S/",
    currency_country: "Peru",
  },
  {
    type: "Currencies",
    currency_code: "PGK-Papua New Guinea Kina",
    currency_symbol: "K",
    currency_country: "Papua New Guinea",
  },
  {
    type: "Currencies",
    currency_code: "PHP-Philippines Peso",
    currency_symbol: "₱",
    currency_country: "Philippines",
  },
  {
    type: "Currencies",
    currency_code: "PKR-Pakistan Rupee",
    currency_symbol: "Rs",
    currency_country: "Pakistan",
  },
  {
    type: "Currencies",
    currency_code: "PLN-Poland Zloty",
    currency_symbol: "zł",
    currency_country: "Poland",
  },
  {
    type: "Currencies",
    currency_code: "PYG-Paraguay Guarani",
    currency_symbol: "₲",
    currency_country: "Paraguay",
  },
  {
    type: "Currencies",
    currency_code: "QAR-Qatar Riyal",
    currency_symbol: "ر.ق",
    currency_country: "Qatar",
  },
  {
    type: "Currencies",
    currency_code: "RON-Romania New Leu",
    currency_symbol: "L",
    currency_country: "Romania",
  },
  {
    type: "Currencies",
    currency_code: "RSD-Serbia Dinar",
    currency_symbol: "din",
    currency_country: "Serbia",
  },
  {
    type: "Currencies",
    currency_code: "RUB-Russia Ruble",
    currency_symbol: "₽",
    currency_country: "Russia",
  },
  {
    type: "Currencies",
    currency_code: "RWF-Rwanda Franc",
    currency_symbol: "FRw",
    currency_country: "Rwanda",
  },
  {
    type: "Currencies",
    currency_code: "SAR-Saudi Arabia Riyal",
    currency_symbol: "﷼‎",
    currency_country: "Saudi Arabia",
  },
  {
    type: "Currencies",
    currency_code: "SBD-Solomon Islands Dollar",
    currency_symbol: "Si$",
    currency_country: "Solomon Islands",
  },
  {
    type: "Currencies",
    currency_code: "SCR-Seychelles Rupee",
    currency_symbol: "SR",
    currency_country: "Seychelles",
  },
  {
    type: "Currencies",
    currency_code: "SDG-Sudan Pound",
    currency_symbol: "ج.س.",
    currency_country: "Republic of the Sudan",
  },
  {
    type: "Currencies",
    currency_code: "SEK-Sweden Krona",
    currency_symbol: "kr",
    currency_country: "Sweden",
  },
  {
    type: "Currencies",
    currency_code: "SGD-Singapore Dollar",
    currency_symbol: "S$",
    currency_country: "Singapore",
  },
  {
    type: "Currencies",
    currency_code: "SHP-Saint Helena Pound",
    currency_symbol: "£",
    currency_country: "Saint Helena",
  },
  {
    type: "Currencies",
    currency_code: "SLL-Sierra Leone Leone",
    currency_symbol: "Le",
    currency_country: "Sierra Leone",
  },
  {
    type: "Currencies",
    currency_code: "SOS-Somalia Shilling",
    currency_symbol: "Sh.so.",
    currency_country: "Somalia",
  },
  {
    type: "Currencies",
    currency_code: "SLS-Somaliland Shilling",
    currency_symbol: "Sl. Sh.",
    currency_country: "Somaliland",
  },
  {
    type: "Currencies",
    currency_code: "SRD-Suriname Dollar",
    currency_symbol: "$",
    currency_country: "Suriname",
  },
  {
    type: "Currencies",
    currency_code: "STD-São Tomé and Príncipe Dobra",
    currency_symbol: "Db",
    currency_country: "São Tomé and Príncipe",
  },
  {
    type: "Currencies",
    currency_code: "SVC-El Salvador Colon",
    currency_symbol: "C",
    currency_country: "El Salvador",
  },
  {
    type: "Currencies",
    currency_code: "SYP-Syria Pound",
    currency_symbol: "£S",
    currency_country: "Syria",
  },
  {
    type: "Currencies",
    currency_code: "SZL-Swaziland Lilangeni",
    currency_symbol: "E",
    currency_country: "Swaziland",
  },
  {
    type: "Currencies",
    currency_code: "THB-Thailand Baht",
    currency_symbol: "฿",
    currency_country: "Thailand",
  },
  {
    type: "Currencies",
    currency_code: "TJS-Tajikistan Somoni",
    currency_symbol: "ЅM",
    currency_country: "Tajikistan",
  },
  {
    type: "Currencies",
    currency_code: "TMT-Turkmenistan Manat",
    currency_symbol: "T",
    currency_country: "Turkmenistan",
  },
  {
    type: "Currencies",
    currency_code: "TND-Tunisia Dinar",
    currency_symbol: "د.ت",
    currency_country: "Tunisia",
  },
  {
    type: "Currencies",
    currency_code: "TOP-Tonga Pa'anga",
    currency_symbol: "PT",
    currency_country: "Tonga",
  },
  {
    type: "Currencies",
    currency_code: "TRY-Turkey Lira",
    currency_symbol: "₺",
    currency_country: "Turkey",
  },
  {
    type: "Currencies",
    currency_code: "TTD-Trinidad and Tobago Dollar",
    currency_symbol: "TT$",
    currency_country: "Trinidad and Tobago",
  },
  {
    type: "Currencies",
    currency_code: "TVD-Tuvalu Dollar",
    currency_symbol: "TV$",
    currency_country: "Tuvalu",
  },
  {
    type: "Currencies",
    currency_code: "TWD-Taiwan New Dollar",
    currency_symbol: "NT$",
    currency_country: "Taiwan",
  },
  {
    type: "Currencies",
    currency_code: "TZS-Tanzania Shilling",
    currency_symbol: "TSh",
    currency_country: "Tanzania",
  },
  {
    type: "Currencies",
    currency_code: "UAH-Ukraine Hryvnia",
    currency_symbol: "₴",
    currency_country: "Ukraine",
  },
  {
    type: "Currencies",
    currency_code: "UGX-Uganda Shilling",
    currency_symbol: "USh",
    currency_country: "Uganda",
  },
  {
    type: "Currencies",
    currency_code: "USD-United States Dollar",
    currency_symbol: "$",
    currency_country: "United States Of America (USA)",
  },
  {
    type: "Currencies",
    currency_code: "UYU-Uruguay Peso",
    currency_symbol: "$U",
    currency_country: "Uruguay",
  },
  {
    type: "Currencies",
    currency_code: "UZS-Uzbekistan Som",
    currency_symbol: "лв",
    currency_country: "Uzbekistan",
  },
  {
    type: "Currencies",
    currency_code: "VEF-Venezuela Bolivar",
    currency_symbol: "Bs.",
    currency_country: "Venezuela",
  },
  {
    type: "Currencies",
    currency_code: "VND-Vietnam Dong",
    currency_symbol: "₫",
    currency_country: "Vietnam",
  },
  {
    type: "Currencies",
    currency_code: "VUV-Vanuatu Vatu",
    currency_symbol: "VT",
    currency_country: "Vanuatu",
  },
  {
    type: "Currencies",
    currency_code: "WST-Samoa Tala",
    currency_symbol: "SAT",
    currency_country: "Samoa",
  },
  {
    type: "Currencies",
    currency_code: "XCD-East Caribbean Dollar",
    currency_symbol: "$",
    currency_country: "Eastern Caribbean States",
  },
  {
    type: "Currencies",
    currency_code: "YER-Yemen Rial",
    currency_symbol: "﷼",
    currency_country: "Yemen",
  },
  {
    type: "Currencies",
    currency_code: "ZAR-South Africa Rand",
    currency_symbol: "R",
    currency_country: "South Africa",
  },
  {
    type: "Currencies",
    currency_code: "ZMW-Zambia Kwacha",
    currency_symbol: "ZK",
    currency_country: "Zambia",
  },
  {
    type: "Currencies",
    currency_code: "ZWD-Zimbabwe Dollar",
    currency_symbol: "Z$",
    currency_country: "Zimbabwe",
  },
];

export let countryData = [
  {
    type: "Countries",
    currency_code: "AFN-Afghanistan Afghani",
    currency_symbol: "؋",
    country_nm: "Afghanistan",
  },
  {
    type: "Countries",
    currency_code: "ALL-Albania Lek",
    currency_symbol: "Lek",
    country_nm: "Albania",
  },
  {
    type: "Countries",
    currency_code: "AMD-Armenia Dram",
    currency_symbol: "֏",
    country_nm: "Armenia",
  },
  {
    type: "Countries",
    currency_code: "AOA-Angola Kwanza",
    currency_symbol: "Kz",
    country_nm: "Angola",
  },
  {
    type: "Countries",
    currency_code: "ARS-Argentina Peso",
    currency_symbol: "$",
    country_nm: "Argentina",
  },
  {
    type: "Countries",
    currency_code: "AUD-Australia Dollar",
    currency_symbol: "$",
    country_nm: "Australia",
  },
  {
    type: "Countries",
    currency_code: "AWG-Aruba Guilder",
    currency_symbol: "ƒ",
    country_nm: "Aruba",
  },
  {
    type: "Countries",
    currency_code: "AZN-Azerbaijan New Manat",
    currency_symbol: "₼",
    country_nm: "Azerbaijan",
  },
  {
    type: "Countries",
    currency_code: "BAM-Bosnia and Herzegovina Convertible Marka",
    currency_symbol: "KM",
    country_nm: "Bosnia and Herzegovina",
  },
  {
    type: "Countries",
    currency_code: "BBD-Barbados Dollar",
    currency_symbol: "Bds$",
    country_nm: "Barbados",
  },
  {
    type: "Countries",
    currency_code: "BDT-Bangladesh Taka",
    currency_symbol: "৳",
    country_nm: "Bangladesh",
  },
  {
    type: "Countries",
    currency_code: "BGN-Bulgaria Lev",
    currency_symbol: "Лв",
    country_nm: "Bulgaria",
  },
  {
    type: "Countries",
    currency_code: "BHD-Bahrain Dinar",
    currency_symbol: ".د.ب",
    country_nm: "Bahrain",
  },
  {
    type: "Countries",
    currency_code: "BIF-Burundi Franc",
    currency_symbol: "FBu",
    country_nm: "Burundi",
  },
  {
    type: "Countries",
    currency_code: "BMD-Bermuda Dollar",
    currency_symbol: "$",
    country_nm: "Bermuda",
  },
  {
    type: "Countries",
    currency_code: "BND-Brunei Darussalam Dollar",
    currency_symbol: "B$",
    country_nm: "Brunei Darussalam",
  },
  {
    type: "Countries",
    currency_code: "BOB-Bolivia Boliviano",
    currency_symbol: "Bs",
    country_nm: "Bolivia",
  },
  {
    type: "Countries",
    currency_code: "BRL-Brazil Real",
    currency_symbol: "R$",
    country_nm: "Brazil",
  },
  {
    type: "Countries",
    currency_code: "BSD-Bahamas Dollar",
    currency_symbol: "B$",
    country_nm: "Bahamas",
  },
  {
    type: "Countries",
    currency_code: "BTN-Bhutan Ngultrum",
    currency_symbol: "Nu.",
    country_nm: "Bhutan",
  },
  {
    type: "Countries",
    currency_code: "BWP-Botswana Pula",
    currency_symbol: "P",
    country_nm: "Botswana",
  },
  {
    type: "Countries",
    currency_code: "BYR-Belarus Ruble",
    currency_symbol: "Br",
    country_nm: "Belarus",
  },
  {
    type: "Countries",
    currency_code: "BZD-Belize Dollar",
    currency_symbol: "$",
    country_nm: "Belize",
  },
  {
    type: "Countries",
    currency_code: "CAD-Canada Dollar",
    currency_symbol: "C$",
    country_nm: "Canada",
  },
  {
    type: "Countries",
    currency_code: "CDF-Congo/Kinshasa Franc",
    currency_symbol: "FC",
    country_nm: "Democratic Republic of the Congo",
  },
  {
    type: "Countries",
    currency_code: "CHF-Switzerland Franc",
    currency_symbol: "Fr.",
    country_nm: "Switzerland",
  },
  {
    type: "Countries",
    currency_code: "CLP-Chile Peso",
    currency_symbol: "$",
    country_nm: "Chile",
  },
  {
    type: "Countries",
    currency_code: "CNY-China Yuan Renminbi",
    currency_symbol: "¥",
    country_nm: "China",
  },
  {
    type: "Countries",
    currency_code: "COP-Colombia Peso",
    currency_symbol: "$",
    country_nm: "Colombia",
  },
  {
    type: "Countries",
    currency_code: "CRC-Costa Rica Colon",
    currency_symbol: "₡",
    country_nm: "Costa Rica",
  },
  {
    type: "Countries",
    currency_code: "CUP-Cuba Peso",
    currency_symbol: "$MN",
    country_nm: "Cuba",
  },
  {
    type: "Countries",
    currency_code: "CVE-Cape Verde Escudo",
    currency_symbol: "$",
    country_nm: "Republic of Cape Verde",
  },
  {
    type: "Countries",
    currency_code: "CZK-Czech Republic Koruna",
    currency_symbol: "Kč",
    country_nm: "Czech Republic",
  },
  {
    type: "Countries",
    currency_code: "DJF-Djibouti Franc",
    currency_symbol: "Fdj",
    country_nm: "Djibouti",
  },
  {
    type: "Countries",
    currency_code: "DKK-Denmark Krone",
    currency_symbol: "Kr.",
    country_nm: "Denmark",
  },
  {
    type: "Countries",
    currency_code: "DOP-Dominican Republic Peso",
    currency_symbol: "RD$",
    country_nm: "Dominican Republic",
  },
  {
    type: "Countries",
    currency_code: "DZD-Algeria Dinar",
    currency_symbol: "دج",
    country_nm: "Algeria",
  },
  {
    type: "Countries",
    currency_code: "EGP-Egypt Pound",
    currency_symbol: "E£",
    country_nm: "Egypt",
  },
  {
    type: "Countries",
    currency_code: "ERN-Eritrea Nakfa",
    currency_symbol: "نافكا",
    country_nm: "Eritrea",
  },
  {
    type: "Countries",
    currency_code: "ETB-Ethiopia Birr",
    currency_symbol: "ብር",
    country_nm: "Ethiopia",
  },
  {
    type: "Countries",
    currency_code: "EUR-Euro Member Countries",
    currency_symbol: "€",
    country_nm: "Euro Member Countries",
  },
  {
    type: "Countries",
    currency_code: "FJD-Fiji Dollar",
    currency_symbol: "FJ$",
    country_nm: "Fiji",
  },
  {
    type: "Countries",
    currency_code: "FKP-Falkland Islands (Malvinas) Pound",
    currency_symbol: "£",
    country_nm: "Falkland Islands (Malvinas)",
  },
  {
    type: "Countries",
    currency_code: "GBP-United Kingdom Pound",
    currency_symbol: "£",
    country_nm: "United Kingdom (UK)",
  },
  {
    type: "Countries",
    currency_code: "GEL-Georgia Lari",
    currency_symbol: "ლ",
    country_nm: "Georgia",
  },
  {
    type: "Countries",
    currency_code: "GGP-Guernsey Pound",
    currency_symbol: "£",
    country_nm: "Guernsey",
  },
  {
    type: "Countries",
    currency_code: "GHS-Ghana Cedi",
    currency_symbol: "GH₵",
    country_nm: "Ghana",
  },
  {
    type: "Countries",
    currency_code: "GIP-Gibraltar Pound",
    currency_symbol: "£",
    country_nm: "Gibraltar",
  },
  {
    type: "Countries",
    currency_code: "GMD-Gambia Dalasi",
    currency_symbol: "D",
    country_nm: "Gambia",
  },
  {
    type: "Countries",
    currency_code: "GNF-Guinea Franc",
    currency_symbol: "GFr",
    country_nm: "Guinea",
  },
  {
    type: "Countries",
    currency_code: "GTQ-Guatemala Quetzal",
    currency_symbol: "Q",
    country_nm: "Guatemala",
  },
  {
    type: "Countries",
    currency_code: "GYD-Guyana Dollar",
    currency_symbol: "G$",
    country_nm: "Guyana",
  },
  {
    type: "Countries",
    currency_code: "HKD-Hong Kong Dollar",
    currency_symbol: "HK$",
    country_nm: "Hong Kong",
  },
  {
    type: "Countries",
    currency_code: "HNL-Honduras Lempira",
    currency_symbol: "L",
    country_nm: "Honduras",
  },
  {
    type: "Countries",
    currency_code: "HRK-Croatia Kuna",
    currency_symbol: "kn",
    country_nm: "Croatia",
  },
  {
    type: "Countries",
    currency_code: "HTG-Haiti Gourde",
    currency_symbol: "G",
    country_nm: "Haiti",
  },
  {
    type: "Countries",
    currency_code: "HUF-Hungary Forint",
    currency_symbol: "Ft",
    country_nm: "Hungary",
  },
  {
    type: "Countries",
    currency_code: "IDR-Indonesia Rupiah",
    currency_symbol: "Rp",
    country_nm: "Indonesia",
  },
  {
    type: "Countries",
    currency_code: "ILS-Israel Shekel",
    currency_symbol: "₪",
    country_nm: "Israel",
  },
  {
    type: "Countries",
    currency_code: "IMP-Isle of Man Pound",
    currency_symbol: "£",
    country_nm: "Isle of Man",
  },
  {
    type: "Countries",
    currency_code: "INR-India Rupee",
    currency_symbol: "₹",
    country_nm: "India",
  },
  {
    type: "Countries",
    currency_code: "IQD-Iraq Dinar",
    currency_symbol: "ع.د",
    country_nm: "Iraq",
  },
  {
    type: "Countries",
    currency_code: "IRR-Iran Rial",
    currency_symbol: "﷼",
    country_nm: "Islamic Republic of Iran",
  },
  {
    type: "Countries",
    currency_code: "ISK-Iceland Krona",
    currency_symbol: "kr",
    country_nm: "Iceland",
  },
  {
    type: "Countries",
    currency_code: "JEP-Jersey Pound",
    currency_symbol: "£",
    country_nm: "Jersey",
  },
  {
    type: "Countries",
    currency_code: "JMD-Jamaica Dollar",
    currency_symbol: "$",
    country_nm: "Jamaica",
  },
  {
    type: "Countries",
    currency_code: "JOD-Jordan Dinar",
    currency_symbol: "د.ا",
    country_nm: "Jordan",
  },
  {
    type: "Countries",
    currency_code: "JPY-Japan Yen",
    currency_symbol: "¥",
    country_nm: "Japan",
  },
  {
    type: "Countries",
    currency_code: "KES-Kenya Shilling",
    currency_symbol: "Ksh",
    country_nm: "Kenya",
  },
  {
    type: "Countries",
    currency_code: "KGS-Kyrgyzstan Som",
    currency_symbol: "Лв",
    country_nm: "Kyrgyzstan",
  },
  {
    type: "Countries",
    currency_code: "KHR-Cambodia Riel",
    currency_symbol: "៛",
    country_nm: "Cambodia",
  },
  {
    type: "Countries",
    currency_code: "KMF-Comoros Franc",
    currency_symbol: "CF",
    country_nm: "Comoros",
  },
  {
    type: "Countries",
    currency_code: "KPW-Korea (North) Won",
    currency_symbol: "₩",
    country_nm: "Democratic People's Republic of Korea",
  },
  {
    type: "Countries",
    currency_code: "KRW-Korea (South) Won",
    currency_symbol: "₩",
    country_nm: "Republic of Korea",
  },
  {
    type: "Countries",
    currency_code: "KWD-Kuwait Dinar",
    currency_symbol: "د.ك",
    country_nm: "Kuwait",
  },
  {
    type: "Countries",
    currency_code: "KYD-Cayman Islands Dollar",
    currency_symbol: "$",
    country_nm: "Cayman Islands",
  },
  {
    type: "Countries",
    currency_code: "KZT-Kazakhstan Tenge",
    currency_symbol: "₸",
    country_nm: "Kazakhstan",
  },
  {
    type: "Countries",
    currency_code: "LAK-Laos Kip",
    currency_symbol: "₭",
    country_nm: "Laos",
  },
  {
    type: "Countries",
    currency_code: "LBP-Lebanon Pound",
    currency_symbol: "ل.ل.‎",
    country_nm: "Lebanon",
  },
  {
    type: "Countries",
    currency_code: "LKR-Sri Lanka Rupee",
    currency_symbol: "Rs",
    country_nm: "Sri Lanka",
  },
  {
    type: "Countries",
    currency_code: "LRD-Liberia Dollar",
    currency_symbol: "L$",
    country_nm: "Liberia",
  },
  {
    type: "Countries",
    currency_code: "LSL-Lesotho Loti",
    currency_symbol: "L",
    country_nm: "Kingdom of Lesotho",
  },
  {
    type: "Countries",
    currency_code: "LYD-Libya Dinar",
    currency_symbol: "ل.د",
    country_nm: "Libya",
  },
  {
    type: "Countries",
    currency_code: "MAD-Morocco Dirham",
    currency_symbol: "د. م.",
    country_nm: "Morocco",
  },
  {
    type: "Countries",
    currency_code: "MDL-Moldova Leu",
    currency_symbol: "L",
    country_nm: "Moldova",
  },
  {
    type: "Countries",
    currency_code: "MGA-Madagascar Ariary",
    currency_symbol: "Ar",
    country_nm: "Madagascar",
  },
  {
    type: "Countries",
    currency_code: "MKD-Macedonia Denar",
    currency_symbol: "Ден",
    country_nm: "Republic of Macedonia",
  },
  {
    type: "Countries",
    currency_code: "MMK-Myanmar (Burma) Kyat",
    currency_symbol: "K",
    country_nm: "Myanmar (Burma)",
  },
  {
    type: "Countries",
    currency_code: "MNT-Mongolia Tughrik",
    currency_symbol: "₮",
    country_nm: "Mongolia",
  },
  {
    type: "Countries",
    currency_code: "MOP-Macau Pataca",
    currency_symbol: "MOP$",
    country_nm: "Macau",
  },
  {
    type: "Countries",
    currency_code: "MRO-Mauritania Ouguiya",
    currency_symbol: "UM",
    country_nm: "Mauritania",
  },
  {
    type: "Countries",
    currency_code: "MUR-Mauritius Rupee",
    currency_symbol: "Rs",
    country_nm: "Mauritius",
  },
  {
    type: "Countries",
    currency_code: "MVR-Maldives (Maldive Islands) Rufiyaa",
    currency_symbol: "Rf",
    country_nm: "Maldives",
  },
  {
    type: "Countries",
    currency_code: "MWK-Malawi Kwacha",
    currency_symbol: "MK",
    country_nm: "Malawi",
  },
  {
    type: "Countries",
    currency_code: "MXN-Mexico Peso",
    currency_symbol: "Mex$",
    country_nm: "Mexico",
  },
  {
    type: "Countries",
    currency_code: "MYR-Malaysia Ringgit",
    currency_symbol: "RM",
    country_nm: "Malaysia",
  },
  {
    type: "Countries",
    currency_code: "MZN-Mozambique Metical",
    currency_symbol: "MT",
    country_nm: "Mozambique",
  },
  {
    type: "Countries",
    currency_code: "NAD-Namibia Dollar",
    currency_symbol: "N$",
    country_nm: "Namibia",
  },
  {
    type: "Countries",
    currency_code: "NGN-Nigeria Naira",
    currency_symbol: "₦",
    country_nm: "Nigeria",
  },
  {
    type: "Countries",
    currency_code: "NIO-Nicaragua Cordoba",
    currency_symbol: "C$",
    country_nm: "Nicaragua",
  },
  {
    type: "Countries",
    currency_code: "NOK-Norway Krone",
    currency_symbol: "kr",
    country_nm: "Norway",
  },
  {
    type: "Countries",
    currency_code: "NPR-Nepal Rupee",
    currency_symbol: "Rs.",
    country_nm: "Nepal",
  },
  {
    type: "Countries",
    currency_code: "NZD-New Zealand Dollar",
    currency_symbol: "$",
    country_nm: "New Zealand",
  },
  {
    type: "Countries",
    currency_code: "OMR-Oman Rial",
    currency_symbol: "ر.ع.",
    country_nm: "Oman",
  },
  {
    type: "Countries",
    currency_code: "PAB-Panama Balboa",
    currency_symbol: "B/.",
    country_nm: "Panama",
  },
  {
    type: "Countries",
    currency_code: "PEN-Peru Nuevo Sol",
    currency_symbol: "S/",
    country_nm: "Peru",
  },
  {
    type: "Countries",
    currency_code: "PGK-Papua New Guinea Kina",
    currency_symbol: "K",
    country_nm: "Papua New Guinea",
  },
  {
    type: "Countries",
    currency_code: "PHP-Philippines Peso",
    currency_symbol: "₱",
    country_nm: "Philippines",
  },
  {
    type: "Countries",
    currency_code: "PKR-Pakistan Rupee",
    currency_symbol: "Rs",
    country_nm: "Pakistan",
  },
  {
    type: "Countries",
    currency_code: "PLN-Poland Zloty",
    currency_symbol: "zł",
    country_nm: "Poland",
  },
  {
    type: "Countries",
    currency_code: "PYG-Paraguay Guarani",
    currency_symbol: "₲",
    country_nm: "Paraguay",
  },
  {
    type: "Countries",
    currency_code: "QAR-Qatar Riyal",
    currency_symbol: "ر.ق",
    country_nm: "Qatar",
  },
  {
    type: "Countries",
    currency_code: "RON-Romania New Leu",
    currency_symbol: "L",
    country_nm: "Romania",
  },
  {
    type: "Countries",
    currency_code: "RSD-Serbia Dinar",
    currency_symbol: "din",
    country_nm: "Serbia",
  },
  {
    type: "Countries",
    currency_code: "RUB-Russia Ruble",
    currency_symbol: "₽",
    country_nm: "Russia",
  },
  {
    type: "Countries",
    currency_code: "RWF-Rwanda Franc",
    currency_symbol: "FRw",
    country_nm: "Rwanda",
  },
  {
    type: "Countries",
    currency_code: "SAR-Saudi Arabia Riyal",
    currency_symbol: "﷼‎",
    country_nm: "Saudi Arabia",
  },
  {
    type: "Countries",
    currency_code: "SBD-Solomon Islands Dollar",
    currency_symbol: "Si$",
    country_nm: "Solomon Islands",
  },
  {
    type: "Countries",
    currency_code: "SCR-Seychelles Rupee",
    currency_symbol: "SR",
    country_nm: "Seychelles",
  },
  {
    type: "Countries",
    currency_code: "SDG-Sudan Pound",
    currency_symbol: "ج.س.",
    country_nm: "Republic of the Sudan",
  },
  {
    type: "Countries",
    currency_code: "SEK-Sweden Krona",
    currency_symbol: "kr",
    country_nm: "Sweden",
  },
  {
    type: "Countries",
    currency_code: "SGD-Singapore Dollar",
    currency_symbol: "S$",
    country_nm: "Singapore",
  },
  {
    type: "Countries",
    currency_code: "SHP-Saint Helena Pound",
    currency_symbol: "£",
    country_nm: "Saint Helena",
  },
  {
    type: "Countries",
    currency_code: "SLL-Sierra Leone Leone",
    currency_symbol: "Le",
    country_nm: "Sierra Leone",
  },
  {
    type: "Countries",
    currency_code: "SOS-Somalia Shilling",
    currency_symbol: "Sh.so.",
    country_nm: "Somalia",
  },
  {
    type: "Countries",
    currency_code: "SLS-Somaliland Shilling",
    currency_symbol: "Sl. Sh.",
    country_nm: "Somaliland",
  },
  {
    type: "Countries",
    currency_code: "SRD-Suriname Dollar",
    currency_symbol: "$",
    country_nm: "Suriname",
  },
  {
    type: "Countries",
    currency_code: "STD-São Tomé and Príncipe Dobra",
    currency_symbol: "Db",
    country_nm: "São Tomé and Príncipe",
  },
  {
    type: "Countries",
    currency_code: "SVC-El Salvador Colon",
    currency_symbol: "C",
    country_nm: "El Salvador",
  },
  {
    type: "Countries",
    currency_code: "SYP-Syria Pound",
    currency_symbol: "£S",
    country_nm: "Syria",
  },
  {
    type: "Countries",
    currency_code: "SZL-Swaziland Lilangeni",
    currency_symbol: "E",
    country_nm: "Swaziland",
  },
  {
    type: "Countries",
    currency_code: "THB-Thailand Baht",
    currency_symbol: "฿",
    country_nm: "Thailand",
  },
  {
    type: "Countries",
    currency_code: "TJS-Tajikistan Somoni",
    currency_symbol: "ЅM",
    country_nm: "Tajikistan",
  },
  {
    type: "Countries",
    currency_code: "TMT-Turkmenistan Manat",
    currency_symbol: "T",
    country_nm: "Turkmenistan",
  },
  {
    type: "Countries",
    currency_code: "TND-Tunisia Dinar",
    currency_symbol: "د.ت",
    country_nm: "Tunisia",
  },
  {
    type: "Countries",
    currency_code: "TOP-Tonga Pa'anga",
    currency_symbol: "PT",
    country_nm: "Tonga",
  },
  {
    type: "Countries",
    currency_code: "TRY-Turkey Lira",
    currency_symbol: "₺",
    country_nm: "Turkey",
  },
  {
    type: "Countries",
    currency_code: "TTD-Trinidad and Tobago Dollar",
    currency_symbol: "TT$",
    country_nm: "Trinidad and Tobago",
  },
  {
    type: "Countries",
    currency_code: "TVD-Tuvalu Dollar",
    currency_symbol: "TV$",
    country_nm: "Tuvalu",
  },
  {
    type: "Countries",
    currency_code: "TWD-Taiwan New Dollar",
    currency_symbol: "NT$",
    country_nm: "Taiwan",
  },
  {
    type: "Countries",
    currency_code: "TZS-Tanzania Shilling",
    currency_symbol: "TSh",
    country_nm: "Tanzania",
  },
  {
    type: "Countries",
    currency_code: "UAH-Ukraine Hryvnia",
    currency_symbol: "₴",
    country_nm: "Ukraine",
  },
  {
    type: "Countries",
    currency_code: "UGX-Uganda Shilling",
    currency_symbol: "USh",
    country_nm: "Uganda",
  },
  {
    type: "Countries",
    currency_code: "AED-United Arab Emirates Dirham",
    currency_symbol: "د.إ",
    country_nm: "United Arab Emirates (UAE)",
  },
  {
    type: "Countries",
    currency_code: "USD-United States Dollar",
    currency_symbol: "$",
    country_nm: "United States Of America (USA)",
  },
  {
    type: "Countries",
    currency_code: "UYU-Uruguay Peso",
    currency_symbol: "$U",
    country_nm: "Uruguay",
  },
  {
    type: "Countries",
    currency_code: "UZS-Uzbekistan Som",
    currency_symbol: "лв",
    country_nm: "Uzbekistan",
  },
  {
    type: "Countries",
    currency_code: "VEF-Venezuela Bolivar",
    currency_symbol: "Bs.",
    country_nm: "Venezuela",
  },
  {
    type: "Countries",
    currency_code: "VND-Vietnam Dong",
    currency_symbol: "₫",
    country_nm: "Vietnam",
  },
  {
    type: "Countries",
    currency_code: "VUV-Vanuatu Vatu",
    currency_symbol: "VT",
    country_nm: "Vanuatu",
  },
  {
    type: "Countries",
    currency_code: "WST-Samoa Tala",
    currency_symbol: "SAT",
    country_nm: "Samoa",
  },
  {
    type: "Countries",
    currency_code: "XCD-East Caribbean Dollar",
    currency_symbol: "$",
    country_nm: "Eastern Caribbean States",
  },
  {
    type: "Countries",
    currency_code: "YER-Yemen Rial",
    currency_symbol: "﷼",
    country_nm: "Yemen",
  },
  {
    type: "Countries",
    currency_code: "ZAR-South Africa Rand",
    currency_symbol: "R",
    country_nm: "South Africa",
  },
  {
    type: "Countries",
    currency_code: "ZMW-Zambia Kwacha",
    currency_symbol: "ZK",
    country_nm: "Zambia",
  },
  {
    type: "Countries",
    currency_code: "ZWD-Zimbabwe Dollar",
    currency_symbol: "Z$",
    country_nm: "Zimbabwe",
  },
];

export let fiscalYearData = [
  {
    type: "Fiscal Year",
    fiscalYear_nm: "January-December",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "February-January",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "March-February",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "April-March",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "May-April",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "June-May",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "July-June",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "August-July",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "September-August",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "October-September",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "November-October",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "December-November",
  },
];
